import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Header,
  Showcase,
  SectionTitle,
  Intro,
} from '../../../../components'
import data from './data.json'

import uf_default from '../../../../images/UploadField_default.png'
import uf_hover from '../../../../images/UploadField_hover.png'
import uf_activeFiles from '../../../../images/UploadField_active-files.png'
import uf_activeImgs from '../../../../images/UploadField_active-imgs.png'
import uf_ulFiles from '../../../../images/UploadField_ul-files.png'
import uf_ulImgs from '../../../../images/UploadField_ul-imgs.png'

export default props => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        title={data.title}
        exclusive={true}
      />
      <Layout
        designOnly="true"
        category="Overview"
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            The upload field pattern prompts users to submit images and files as
            part of a form. The default elements are a{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/label/design'}
            >
              label
            </Link>{' '}
            and an upload container. Add the "Optional" label when the upload
            field is not required. Use a Help Link variant of the{' '}
            <Link class="link" to={'/' + data.site + '/components/link/design'}>
              icon link
            </Link>{' '}
            to communicate additional information when it won't fit in the
            interface. The caption is optional, but can give the user more
            context for how to fill in the field.
          </p>
        </Intro>
        <SectionTitle>States</SectionTitle>

        <Showcase
          site={data.site}
          title="Default"
          text={
            <p>
              Signals that the user can drag files into the dashed container or
              use the "Browse Files" button to open their device's native file
              picker.
            </p>
          }
        >
          <img src={uf_default} alt="Upload Field default state" width="100%" />
        </Showcase>

        <Showcase
          site={data.site}
          title="Hover"
          text={
            <p>
              Signals that the dragged files will upload once dropped. The hover
              state only appears when files are dragged over the dashed
              container, not on mouseover.
            </p>
          }
        >
          <img src={uf_hover} alt="Upload Field hover state" width="100%" />
        </Showcase>

        <Showcase
          site={data.site}
          title="Uploading, files"
          text={
            <p>
              Signals that the dropped or selected files have begun uploading.
              The spinner will display a progress percentage when feasible.
            </p>
          }
        >
          <img src={uf_ulFiles} alt="Files in Uploading state" width="100%" />
        </Showcase>

        <Showcase
          site={data.site}
          title="Uploading, images"
          text={
            <p>
              Signals that the dropped or selected images have begun uploading.
              Each image behaves like the{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/thumbnail/design'}
              >
                thumbnail
              </Link>{' '}
              loading state.
            </p>
          }
        >
          <img src={uf_ulImgs} alt="Images in Uploading state" width="100%" />
        </Showcase>

        <Showcase
          site={data.site}
          title="Active, files"
          text={
            <p>
              Signals that files have finished uploading. The button in this
              state is optional, but will pair an action with each file, such as
              "Edit" or "Delete".
            </p>
          }
        >
          <img src={uf_activeFiles} alt="Uploaded Files" width="100%" />
        </Showcase>

        <Showcase
          site={data.site}
          title="Active, images"
          text={
            <p>
              Signals that images have finished uploading. Each image behaves
              like the{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/thumbnail/design'}
              >
                thumbnail
              </Link>{' '}
              loading state.
            </p>
          }
        >
          <img src={uf_activeImgs} alt="Uploaded Images" width="100%" />
        </Showcase>

        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Form action groups will default to the persistent position, but can be
          placed in-scroll if that works better for the design. Use nested
          columns in tablet and desktop views to make the most of the horizontal
          form space.
        </p>
        <p>
          If a form calls for more than one upload field, consider separating
          them on different pages or in a{' '}
          <Link
            class="link"
            to={'/' + data.site + '/patterns/step-guide/design'}
          >
            step guide
          </Link>
          . The icon, text and button included in the default state appear on a
          single line on tablet and desktop. In mobile view, they stack. The
          width of the pattern fits four thumbnails across on tablet and desktop
          and two across in mobile.
        </p>
        <hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          The optional label will always be "Optional" and the text and button
          label in the default state will always be "Drag {'&'} Drop" or "Browse
          Files". Otherwise, follow the guidelines for the{' '}
          <Link class="link" to={'/' + data.site + '/components/link/design'}>
            icon link
          </Link>
          ,{' '}
          <Link class="link" to={'/' + data.site + '/components/label/design'}>
            label
          </Link>{' '}
          and{' '}
          <Link
            class="link"
            to={'/' + data.site + '/components/thumbnail/design'}
          >
            thumbnail
          </Link>
          .
        </p>
      </Layout>
    </>
  )
}
